export const legendConfigs = {
  aqi_eu: {
    title: 'AQI',
    values: [1, 2, 3, 4, 5, 6],
    colors: [
      '#559f58',
      '#a7d35c',
      '#ecd448',
      '#f5be41',
      '#f09235',
      '#da3322'
    ],
    units: null
  },
  pm25: {
    title: 'PM2.5',
    values: [0, 10, 20, 25, 50, 75, '75+'],
    colors: [
      '#559f58',
      '#a7d35c',
      '#ecd448',
      '#f5be41',
      '#f09235',
      '#da3322'
    ],
    units: 'μg/m3'
  },
  pm10: {
    title: 'PM10',
    values: [0, 20, 40, 50, 100, 150, '150+'],
    colors: [
      '#559f58',
      '#a7d35c',
      '#ecd448',
      '#f5be41',
      '#f09235',
      '#da3322'
    ],
    units: 'μg/m3'
  },
  o3: {
    title: 'O3',
    values: [0, 50, 100, 130, 240, 380, '380+'],
    colors: [
      '#559f58',
      '#a7d35c',
      '#ecd448',
      '#f5be41',
      '#f09235',
      '#da3322'
    ],
    units: 'μg/m3'
  },
  no2: {
    title: 'NO2',
    values: [0, 40, 90, 120, 230, 340, '340+'],
    colors: [
      '#559f58',
      '#a7d35c',
      '#ecd448',
      '#f5be41',
      '#f09235',
      '#da3322'
    ],
    units: 'μg/m3'
  }
}
